<div class="support-modal-overlay" *ngIf="showModal" (click)="onOverlayClick()">
  <div class="support-modal" (click)="stopPropagation($event)">
    <div
      class="modal-header d-flex ion-justify-content-between ion-align-items-center pad10"
    >
      <div class="d-flex ion-align-items-center marr10 flex-1">
        <ion-img
          class="support-icon-img marr10"
          src="assets/images/contact_support.png"
          alt="Support"
        ></ion-img>

        <div class="d-flex flex-col flex-1">
          <p class="fs-4 font700 title-text-color mar0 pad0 mart5">
            {{ "bus.booking_confirmation.support_and_assistance" | translate }}
          </p>
          <p
            class="fs-3 font500 card-secondary-text-color l-height150 mar0 pad0"
          >
            {{
              "bus.booking_confirmation.for_questions_regarding_refund_or_cancellation"
                | translate
            }}
          </p>
        </div>
      </div>
      <ion-button fill="clear" class="close-btn" (click)="onCloseClick()">
        <ion-icon
          name="close-outline"
          class="close-icon fs-5 subtitle-text-color"
        ></ion-icon>
      </ion-button>
    </div>
    <div class="modal-content pad10">
      <div class="padl10 padr10">
        <div>
          <p
            class="fs-3 font500 card-secondary-text-color"
            *ngIf="theme.getEmailSupport"
          >
            {{ "bus.booking_confirmation.email_support" | translate }}
            <a
              [href]="'mailto:' + theme.getEmailSupport"
              class="contact-value fs-3 font500 blue-text-color"
            >
              {{ theme.getEmailSupport }}
            </a>
          </p>
        </div>
        <div>
          <p
            class="fs-3 font500 card-secondary-text-color"
            *ngIf="theme.getChatSupport"
          >
            {{ "bus.booking_confirmation.whatsapp_support" | translate }}
            <a
              [href]="'https://wa.me/' + theme.getChatSupport"
              target="_blank"
              class="contact-value fs-3 font500 blue-text-color"
            >
              +{{ theme.getChatSupport }}
            </a>
          </p>
        </div>
      </div>
      <div class="padl10 padr10">
        <p
          class="fs-2 font500 card-secondary-text-color l-height150"
          *ngIf="showPnrInfo"
        >
          {{ "bus.booking_confirmation.keep_your" | translate }}
          <span class="font600">{{
            "bus.booking_confirmation.pnr" | translate
          }}</span>
          and
          <span class="font600">{{
            "bus.booking_confirmation.ticket_number" | translate
          }}</span>
          {{
            "bus.booking_confirmation.handy_for_faster_assistance" | translate
          }}
        </p>
        <p
          class="fs-2 font500 card-secondary-text-color l-height150"
          *ngIf="!showPnrInfo && customInfoText"
        >
          {{ customInfoText }}
        </p>
        <p
          class="fs-2 font500 card-secondary-text-color l-height150"
          *ngIf="!showPnrInfo && !customInfoText"
        >
          {{ "bus.booking_confirmation.keep_your" | translate }}
          <span class="font600">{{
            "bus.booking_confirmation.booking_id" | translate
          }}</span>
          {{
            "bus.booking_confirmation.handy_for_faster_assistance" | translate
          }}
        </p>
      </div>
    </div>
  </div>
</div>
